<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">

						<div class="row m-0 mt-5">
							<div class="col-md-12 m-0 p-0 pr-md-2 pl-md-2">

								<div class="row">
									<div class="col-sm-1"></div>
									<div class="col-sm-10">
									    <h5>コメント詳細</h5>
										<hr>
									</div>
									<div class="col-sm-1"></div>
								</div>

								<div class="row">
									<div class="col-sm-1"></div>
									<div class="col-sm-10 main">

										<div class="card my-3">
											<div class="card-body text-center text-muted">
												<div class="row">
													<div class="col-md-12">
														<p><a @click="jumpProductDetail(products_id)">商品ページへはこちら</a></p>
														<p><span style="color: red;">（注意）コメントは、ピアノ販売ページ上でやり取りされ、公開されます。</span></p>
														<hr>
														<p>コメント</p>
														<p>{{ allGetComments.length }} 件</p>

														<div v-for="(comment, index) in allGetComments">
															<div class="col-2 pl-1 pr-1 m-0">
																<img class="" :src="user_photo_change(comment['image'])" style="width: 100%;height: auto;">
															</div>
															<div class="col-10 pl-2 pr-0 m-0 text-left">
																<p class="mb-2" style="font-size: 0.9rem;" v-if="String(comment['seller'])=='1'">代表: {{ comment['last_name'] + " " + comment['first_name'] }}</p>
																<p class="mb-2" style="font-size: 0.9rem;" v-else>{{ comment['nickname'] }}</p>
																<p class="mb-2">{{ comment['contents'] }}</p>
																<p class="mb-2" style="font-size: 0.9rem;">{{ date_only_format(comment['created_at']) }}</p>
																<template v-if="String(my_user.user_type) == '2' || String(my_user.user_type) == '9'">
																	<button class="btn btn-secondary" @click="deleteComment(comment['id'])">削除</button>
																</template>
															</div>
															<hr>
														</div>
														<p class="mb-2">商品へのコメント</p>
														<textarea placeholder="コメントする" class="required form-control" rows="4" v-model="commentForm.contents" v-bind:class="{ error_input: commentForm.errors.contents.length > 0 }"></textarea>
														<div v-if="commentForm.errors.contents.length > 0">
															<div class="error-text" v-for="(item, index) in commentForm.errors.contents" :key="index">{{ item }}</div>
														</div>
														<button type="button" class="bs100 btn btn-primary mt-3" @click="sendComment">コメントを送信する</button>
													</div>
												</div>
											</div>
										</div>

									</div>
									<div class="col-sm-1"></div>
								</div>

							</div>
						</div>

					</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StarRating from 'vue-star-rating'

export default {
	name: 'ProductComment',
    components: {
	  'star-rating': StarRating,
    },
	data () {
		return {
			products_id: null,
			product: null,
			my_user: null,
			my_user_photos: null,
			product_comments: [],

			isError: true,
			commentForm: {
				errors: {
					contents: [],
				},
				contents: "",
			},
		}
	},
	methods: {
	  sendComment() {
		this.isError = false;
		this.commentForm.errors.contents = [];
		if (!this.commentForm.contents) {
		  this.commentForm.errors.contents.push('コメントが入力されていません');
		  this.isError = true;
		}
		if (!this.isError) {
		  this.send_comment(null, false);
		}
		return false;
	  },
      jumpProductDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },
	  deleteComment: function(id){
		this.send_comment(id, true);
		return false;
	  },
      // コメント送信処理
      async send_comment(id, delete_flg) {
        this.$store.dispatch('product/send_comment', {
		  product_comments_id: id,
		  delete: delete_flg,
          contents: this.commentForm.contents,
          products_id: this.products_id,
        //   users_id: this.,
        }).then(res => {
          console.log(res);
		  if ( delete_flg ) {
			let delete_index = null;
			for (let i = 0; i < this.product_comments.length; i++) {
			  if ( String(this.product_comments[i]['id']) == String(id) ) {
				delete_index = i;
			  }
			}
			this.product_comments.splice(delete_index, 1);
		  } else {
			let image = "", seller = 0;
			if ( this.my_user_photos != null ) {
				image = this.my_user_photos.image;
			}
			if ( this.product.users_id == this.my_user.id ) {
				seller = 1;
			}
			this.product_comments.push({
				id: res.data.product_comment.id,
				image: image,
				contents: this.commentForm.contents,
				nickname: this.my_user.nickname,
				corp_name: this.my_user.corp_name,
				store_name: this.my_user.store_name,
				last_name: this.my_user.last_name,
				first_name: this.my_user.first_name,
				seller: seller,
				created_at: "",
			})
			this.commentForm.contents = "";
		  }
          return false;
        }, error => {
          // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
          console.log(error.response.data);
          if ('error' in error.response.data) {
            alert(error.response.data['error']);
            window.scrollTo({
              top: 0,
            });
          }
        });
        return false;
      },
	  async get_product_detail(id) {
		this.$store.dispatch('product/get_product_detail', {
          id: id,
        }).then(res => {
		  console.log(res);
		  let ret = res.data.product;
		  this.product = ret['product'];
		  this.my_user = ret['my_user'];
		  this.my_user_photos = ret['my_user_photos'];
		  this.product_comments = ret['product_comments'];
		  console.log(this.product);
		  console.log(this.my_user);
		  console.log(this.my_user_photos);
		  console.log(this.product_comments);
		}, error => {
		  console.log('error発生');
		  console.log(error);
		  this.$nextTick(() => {
            window.scrollTo({
              top: 0,
            });
		  });
	    });
	  },
	},
	created() {
		this.products_id = this.$route.params.products_id;
		this.get_product_detail(this.products_id);
	},
	computed: {
		allGetComments: function() {
			return this.product_comments;
		},
	},
}
</script>

<style scoped>
.vue-star-rating {
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductComment.vue